import gsap from 'gsap'

const init = (el) => {
  const params = {
    autoAlpha: 0,
    y: 30,
  }

  return gsap.set(el.children, Object.assign({}, params))
}

const anim = (el, extraParams) => {
  const params = {
    autoAlpha: 1,
    y: 0,
    clearProps: 'transform',
    ease: 'expo.out',
    duration: 1,
    clearProps: 'all',
    stagger: {
      amount: 0.6,
    }
  }
  return gsap.to(el.children, Object.assign({}, params, extraParams))
}

export {
  init,
  anim
}
